import React, { CSSProperties } from "react"
import Texts from "../Texts"

type Props = {
  label?: string
  url: string
  className?: string
  style?: CSSProperties
  onClick?: () => void
  figure?: React.ReactNode
  complexClassName?: string
}

const Image = ({
  label = "",
  url,
  className,
  style,
  onClick,
  figure,
  complexClassName = "max-h-[500px] max-w-[800px]",
}: Props) => {
  if (!figure) {
    return (
      <img
        alt={label}
        className={className}
        style={style}
        src={url}
        onClick={onClick}
      />
    )
  }

  return (
    <div
      className={`flex flex-col text-center justify-center w-full ${complexClassName}`}
    >
      <img
        alt={label}
        className={`${className} h-full w-full`}
        style={style}
        src={url}
        onClick={onClick}
      />
      <div className="p-2 md:p-4" />
      <span className="font-raleway-extralight text-[8px] sm:text-xs md:text-sm">
        {figure}
      </span>
    </div>
  )
}

export default Image
